// ==============================|| PRESET THEME - DEFAULT ||============================== //

export default function Default(colors) {
  const { primary, secondary, red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: primary[0],
      100: primary[1],
      200: primary[2],
      light: primary[3],
      400: primary[4],
      main: primary[5],
      dark: primary[6],
      700: primary[7],
      darker: primary[8],
      900: primary[9],
      contrastText
    },
    secondary: {
      lighter: secondary[0],
      100: secondary[1],
      200: secondary[2],
      light: secondary[3],
      400: secondary[4],
      main: secondary[5],
      600: secondary[6],
      dark: secondary[7],
      800: secondary[8],
      darker: secondary[9],
      A100: secondary[0],
      A200: secondary[2],
      A300: secondary[3],
      contrastText: greyColors[0]
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
}
